var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mask"},[_c('div',{staticClass:"inner-mask"},[_vm._t("portal")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }